<template>
	<div class="v-select-search" ref="input">
		<v-input v-model="keywords" :placeholder="placeholder" @input="input" ref="inner" clearable/>
	</div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    placeholder: {
      default: null
    }
  },
  data() {
    return {
      text: ""
    };
  },
  computed: {
    keywords: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    input(e) {
      this.$timeout(
        () => {
          this.$parent.$parent.loading = true;
          this.$emit("search", () => {
            this.$parent.$parent.loading = false;
          });
        },
        500,
        "v-select-search-input"
      );
    }
  },
  mounted() {
    this.$bindEvents(this.$refs.inner);
  }
};
</script>




// WEBPACK FOOTER //
// src/vue-ext/components/popover/select/search.vue